import { render, staticRenderFns } from "./batchEditTeachers.vue?vue&type=template&id=0578ed5f&"
import script from "./batchEditTeachers.vue?vue&type=script&lang=js&"
export * from "./batchEditTeachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports